export const RoutesDefault = [
  {
    regex: /^\/?$/,
    title: 'Página Inicial',
  },
  {
    regex: /^\/\$error\/?$/,
    title: 'Página não encontrada',
  },
  {
    regex: /^\/blank\/?$/,
    title: 'Página em branco',
  },
  {
    regex: /^\/login\/?$/,
    title: 'Login',
  },
]
export default []
